import { createContext } from 'react'

import { features } from '@h2/components/media'

const Context = createContext({
  isMobile: !window.matchMedia(`(${features.minWidth.laptop})`).matches
})

export { Context }
